__webpack_require__.p = "/wp-content/reactpress/apps/myapp/build/";